import React from 'react';
import { theme } from '../theme';

const PageLayout = ({ title, subtitle, action, maxWidth = 1100, children }) => (
  <div className="page-layout" style={{ maxWidth, margin: '0 auto', fontFamily: theme.font }}>
    {(title || action) && (
      <div className="page-layout-header" style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
        marginBottom: 24, flexWrap: 'wrap', gap: 12,
      }}>
        <div style={{ minWidth: 0 }}>
          {title && <h1 className="page-title" style={{ fontSize: 24, fontWeight: 700, color: theme.colors.text, margin: 0, letterSpacing: '-0.02em' }}>{title}</h1>}
          {subtitle && <p style={{ fontSize: 14, color: theme.colors.textSecondary, margin: '4px 0 0' }}>{subtitle}</p>}
        </div>
        {action && <div className="page-actions" style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>{action}</div>}
      </div>
    )}
    {children}
  </div>
);

export default PageLayout;
